import styled from "styled-components";

export const StyledOpenBankingInprogressStep = styled.div`
	max-width: 63rem;
`;